import { debounce } from 'throttle-debounce';
import { ca } from '@cian/analytics';
import { CHART_DEBOUNCE_DELAY } from '../MarketTrendsContainer/utils/constants';

export const trackOnChartHover = debounce(CHART_DEBOUNCE_DELAY, () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'EstateCalculator',
    action: 'Click',
    label: 'PriceDynamicChartAction',
  });
});

/**
 * Трекаем доступность блока "Динамика цен" на странице
 */
export function trackPriceDynamicExist() {
  ca('teaser', {
    product: {
      name: 'price_dynamic_exist',
    },
  });
}
